module.exports = __webpack_public_path__ + "img/case_6.b012635e.png";